"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconDropDownChain = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M61.42 42.56v-.32h-7a8.46 8.46 0 0 1 5.23 2.19 3.41 3.41 0 0 1 1.77-1.87zM19.28 40.78h42.14v-9.07H19.28zm2.64-6.43h36.86v3.8H21.92zM39.93 48.68h-18v-3.8h19.61q.23-.28.5-.55a7.32 7.32 0 0 1 4.19-2.08H19.28v9.07H40.1a7 7 0 0 1-.16-2.63zM47.26 48.95a.59.59 0 0 0-.43.18.58.58 0 0 0-.18.43.68.68 0 0 0 .66.66H49a3.38 3.38 0 0 1 1.29.26v-.25a3.37 3.37 0 0 1 .22-1.23zM58.78 59.14H21.92v-3.8h20.73a7.61 7.61 0 0 1-.59-.53 7.46 7.46 0 0 1-1.47-2.1H19.28v9.07h42.14v-4.73h-2.64zM51.64 23.14l2.89-3.67h-5.77l2.88 3.67z"
  }), _react["default"].createElement("path", {
    d: "M58.49 28.64v-15.8H4.95v15.8h53.54zM47.08 15.47h8.78V26h-8.78zM44.45 26H7.58V15.47h36.87zM64.93 44.19h-2.06a1.44 1.44 0 0 0 0 2.87h2.06c1.52 0 2.2 1.31 2.2 2.61a2.55 2.55 0 0 1-2.56 2.57h-6.49c-3 0-3-1.4-3-2a1.44 1.44 0 0 0-1.44-1.43 1.44 1.44 0 0 0-1.43 1.44 4.54 4.54 0 0 0 1.27 3.3 6.33 6.33 0 0 0 4.57 1.56h6.49A5.42 5.42 0 0 0 70 49.66c0-3.16-2.14-5.46-5.07-5.47z"
  }), _react["default"].createElement("path", {
    d: "M49 52.18h-1.69a2.63 2.63 0 0 1-2.61-2.61A2.55 2.55 0 0 1 47.26 47h6.09c1.26 0 3.38.27 3.38 2a1.44 1.44 0 0 0 1.44 1.43A1.44 1.44 0 0 0 59.62 49c0-2.94-2.46-4.85-6.25-4.86h-6.09a5.43 5.43 0 0 0-5.43 5.45A5.51 5.51 0 0 0 47.3 55H49a1.44 1.44 0 0 0 0-2.87z"
  })),
  height: undefined,
  width: undefined
});
IconDropDownChain.displayName = 'IconDropDownChain';
var _default = IconDropDownChain;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/drop-down-chain.js
// module id = 567
// module chunks = 0